import { render, staticRenderFns } from "./UserCircleIcon.vue?vue&type=template&id=12d9abd4&"
import script from "./UserCircleIcon.vue?vue&type=script&lang=ts&"
export * from "./UserCircleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UserCircleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports